import { getMapContentStoreId } from "../utils";
import { IWasmStoreGeometry, TBulkOperations } from "./interfaces";
import { applyStoreItem } from "./utils";

export default class WasmStoreGeometry {
	#data: IWasmStoreGeometry;

	#bulkMode: boolean;

	#bulkOperations: Array<TBulkOperations>;

	constructor(opts: Partial<IWasmStoreGeometry>, bulkMode = false) {
		this.#data = {
			id: getMapContentStoreId(),
			lastChange: 0,
			lastGeomChange: 0,
			points: [],
			strPoints: [],
			type: "measure-current",
			visual: "standard",
			bringToTheFront: false,
			customData: null,
			multilineData: null,
			visible: true,
			popupVisible: false,
			customStyleHash: null,
			zIndex: null,
			interactionType: "none",
			...opts,
		};
		this.#bulkMode = bulkMode;
		this.#bulkOperations = [];
		// posleme dal
		this.#addBulkItem({ type: "add-geometry", data: this.#data });
	}

	update(updData: Partial<IWasmStoreGeometry>) {
		const changes = {
			...updData,
			lastChange: this.#data.lastChange + 1,
		};

		// zmena geometrie
		if ("points" in changes || "strPoints" in changes) {
			changes.lastGeomChange = this.#data.lastGeomChange + 1;
		}

		this.#data = {
			...this.#data,
			...changes,
		};

		// posleme dal
		this.#addBulkItem({ type: "update-geometry", id: this.#data.id, data: changes });
	}

	get id() {
		return this.#data.id;
	}

	get data() {
		return this.#data;
	}

	set bulkMode(bulkMode: boolean) {
		this.#bulkMode = bulkMode;
	}

	get bulkOperations() {
		return this.#bulkOperations;
	}

	clearBulkOperations() {
		this.#bulkOperations.length = 0;
	}

	destroy() {
		// posleme dal
		this.#addBulkItem({ type: "remove-geometry", id: this.#data.id });
	}

	#addBulkItem(oper: TBulkOperations) {
		if (this.#bulkMode) {
			this.#bulkOperations.push(oper);
		} else {
			applyStoreItem(oper);
		}
	}
}
